<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>运费收入</h4>
        </div>
        <!-- 查询条件 -->
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">

    <el-form-item label="业务单号:" prop="businessNo">
              <el-input v-model="formInline.businessNo" size="mini" placeholder="请输入业务单号"></el-input>
            </el-form-item>

   <el-form-item label="收款状态:">
              <el-select
                size="mini"
                v-model="formInline.goodsType"
                placeholder="请选择收款状态"
                style="width:175px"
              >
                <el-option
                  v-for="item in typeData"
                  :label="item.show_name"
                  :key="item.show_name"
                  :value="item.item_no"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="收款时间:">

           <el-date-picker

                v-model="formInline.daoTime"
                size="mini"
                style="width:195px"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>

            </el-form-item>

            <el-form-item>
              <div style="margin-left:20px;">
                <el-button
                  type="primary"
                  size="mini"
                  @click="chaxun"
                  btnCode="006P00GB001"
                >查询</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="chongZhi"
                  btnCode="006P00GB002"
                >重置</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--表格1-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table
          border
          height="100%"
          size="mini"
          ref="tabref"
          :data="tableList"
          style="width:100%"
          class="elTab"
          highlight-current-row
          @row-click="dianjixuanzhong"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >

         <el-table-column  type="index"  width="55" label="序号"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="businessNo"
            label="业务单号"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="seeClickNO(scope.row)"
              >{{scope.row.businessNo}}</el-button>
            </template>
          </el-table-column>

   <el-table-column
            :show-overflow-tooltip="true"
            prop="settlementStatus"
            label="收款状态"
            align="center"
            :formatter="emptyFn"
            width="120"
          >
            <template slot-scope="scope">
              <div>
              <span v-if="scope.row.settlementStatus =='1301'" style="color:red;">待收款</span>
              <span v-else-if="scope.row.settlementStatus !=='1301'">已收款</span>
              </div>
            </template>
          </el-table-column>

  <el-table-column
            :show-overflow-tooltip="true"
            prop="weight"
            label="结算量"
            align="center"
            :formatter="emptyFn"
            width="150"
          ></el-table-column>

 <el-table-column property="publishPricingMethod" label="计价方式"  width="150">
          <template scope="scope">{{[ "单价", "包干",][scope.row.pricingMethod-1]}}</template>
        </el-table-column>
       <el-table-column property="unitPrice" width="150"     label="单价(元)">
          <template scope="scope">
            <div>
            <span v-if="scope.row.pricingMethod==1">{{scope.row.unitPrice}}元/{{scope.row.unitMeasurement}}</span>
            <span v-if="scope.row.pricingMethod==2">-</span>
            </div>
          </template>
        </el-table-column>

 <el-table-column
            :show-overflow-tooltip="true"
            prop="totalAmount"
            label="应收合计(元)"
            align="center"
            :formatter="emptyFn"
             min-width="150"
          >
              <template slot-scope="scope">
               <span style="color: #0e6eec;cursor: pointer;font-size:14px" @click="YFHJfn(scope.row)">{{scope.row.totalAmount}}</span>
            </template>

          </el-table-column>

   <el-table-column
            prop="settlementTime"
            label="收款时间"
            :formatter="dateFormat"
            align="center"
          ></el-table-column>

        </el-table>
      </div>
      <!--分页-->
      <div class="pags" style="text-align: left;">
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <div>
      <el-dialog
        :title="this.titleDetail"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="80%"
        center
        :before-close="handleClose"
      >
        <!-- ==================================================================================订单 -->
        <div v-loading="loading">
          <el-form
            :inline="true"
            ref="goodform"
            enctype="multipart/form-data"
            :model="goodform"
            class="demo-form-inline"
            label-width="180px"
            size="mini"
          >
            <div class="addressBoxTitle" v-if="this.num=='0'">
              <div>订单号 ：{{goodform.orderNo}}</div>
            </div>
            <div class="addressBoxTitle" v-else-if="this.num=='1'">
              <div>运单号 ：{{goodform.wayNo}}</div>
              <div>所属订单 ：{{goodform.orderNo}}</div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息
                </span>
              </h4>
              <div>
                <el-form-item label="货物类型 :" class="jiage" prop="productType">
                  <span>{{goodform.productTypeName}}</span>
                </el-form-item>
                <el-form-item label="调度量 :" class="jiage" prop="weight">
                  <span>{{goodform.weight}}</span>
                  <span class>{{goodform.unitMeasurement}}</span>
                </el-form-item>
                <el-form-item label="装车量 :" class="jiage" prop="num">
                  <span>{{goodform.loadingWeight}}</span>
                  <span class>{{goodform.unitMeasurement}}</span>
                </el-form-item>
                <el-form-item label="卸车量 :" class="jiage" prop="num">
                  <span>{{goodform.unloadingWeight}}</span>
                  <span class>{{goodform.unitMeasurement}}</span>
                </el-form-item>
              </div>
              <div>
                <!-- <el-form-item label="货物件数 :" class="jiage" prop="productType" v-if="this.num=='0'">
                  <span>{{goodform.num}}</span>
                  <span class>件</span>
                </el-form-item>-->
                <!-- <el-form-item
                  label="计价方式 :"
                  class="jiage"
                  prop="pricingMethod"
                  v-if="this.num=='0'"
                >
                  <span v-if="goodform.pricingMethod=='1'">按吨</span>
                  <span v-else-if="goodform.pricingMethod=='2'">包干</span>
                  <span class></span>
                </el-form-item>
                <el-form-item
                  label="计价方式 :"
                  class="jiage"
                  prop="valuationType"
                  v-if="this.num=='1'"
                >
                  <span>{{goodform.valuationType}}</span>
                  <span class></span>
                </el-form-item>
                <el-form-item label="单价 :" class="jiage" prop="unitPrice" v-if="this.num=='0'">
                  <span v-if="goodform.pricingMethod=='2'">-</span>
                  <span v-else-if="goodform.pricingMethod !== '2'">
                      {{ goodform.publishTonPrice }}
                      <span class>元</span>
                      <span>
                        <span v-if="goodform.unitMeasurement">/</span>
                        {{ goodform.unitMeasurement }}
                      </span>
                    </span>
                </el-form-item>
                <el-form-item label="单价 :" class="jiage" prop="fatePrice" v-if="this.num=='1'">
                  <span>{{goodform.fatePrice}}</span>
                  <span class>元</span>
                </el-form-item>
                <el-form-item label="运费 :" class="jiage" prop="actualDealPrice" v-if="this.num=='0'">
                  <span style="color:#F56C6C">{{goodform.actualDealPrice}}</span>
                  <span class>元</span>
                </el-form-item>
                <el-form-item label="运费 :" class="jiage" prop="actualDealPrice" v-if="this.num=='1'">
                  <span style="color:#F56C6C">{{goodform.actualDealPrice}}</span>
                  <span class>元</span>
                </el-form-item> -->
                <!-- <el-form-item label="服务费 :" class="jiage" prop="taxation" >
                  <span style="color: #f56c6c">{{ goodform.taxation }}</span>
                  <span class>元</span>
                </el-form-item>
                <el-form-item label="运费合计 :" class="jiage" prop="fatePrice" >
                  <span style="color: #f56c6c">{{ sun}}</span>
                  <span class>元</span>
                </el-form-item> -->
              </div>
              <div v-if="this.num=='0'">
                <el-form-item label="发单时间 :" class="jiage" prop="transportStartOperateDate">
                  <span>{{goodform.transportStartOperateDate |dateFormat}}</span>
                </el-form-item>
                <el-form-item label="送达时间 :" class="jiage" prop="transportEndOperateDate">
                  <span>{{goodform.transportEndOperateDate|dateFormat}}</span>
                  <span class></span>
                </el-form-item>
              </div>
              <div v-else-if="this.num=='1'">
                <el-form-item label="接单时间 :" class="jiage" prop="receivingTime">
                  <span>{{goodform.receivingTime|dateFormat}}</span>
                </el-form-item>
                <el-form-item label="送达时间 :" class="jiage" prop="arrivalTime">
                  <span>{{goodform.arrivalTime|dateFormat}}</span>
                  <span class></span>
                </el-form-item>
              </div>
            </div>
            <hr />
            <div class="addressBox">
              <h4 class="title">
                <span>
                  <i class="fa fa-envelope iconFont" aria-hidden="true"></i>货运信息
                </span>
              </h4>
              <div class="box1">
                <div class="item">
                  <div class="box1T" v-if="this.num=='0'">
                    <i style="color:#FC9727" class="el-icon-location"></i>
                    发货地址 ：
                    <span
                      style="color:#FC9727"
                    >{{goodform.deliverCompany}}</span>
                  </div>
                  <div class="box1T" v-else-if="this.num=='1'">
                    <i style="color:#FC9727" class="el-icon-location"></i>
                    装货地址 ：
                    <span
                      style="color:#FC9727"
                    >{{goodform.deliverCompany}}</span>
                  </div>
                  <div class="box1B">
                    <span>{{goodform.deliverPerson}}&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <span>{{goodform.deliverPhone}}&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <span>{{goodform.deliverAddress}}</span>
                  </div>
                </div>
                <div class="item">
                  <div class="box1T" v-if="this.num=='0'">
                    <i style="color:#1EA827" class="el-icon-location"></i>
                    收货地址 ：
                    <span
                      style="color:#1EA827"
                    >{{goodform.receivingCompany}}</span>
                  </div>
                  <div class="box1T" v-else-if="this.num=='1'">
                    <i style="color:#1EA827" class="el-icon-location"></i>
                    卸货地址 ：
                    <span
                      style="color:#1EA827"
                    >{{goodform.receivingCompany}}</span>
                  </div>
                  <div class="box1B">
                    <span>{{goodform.receivingPerson}}&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <span>{{goodform.receivingPhone}}&nbsp;&nbsp;/&nbsp;&nbsp;</span>
                    <span>{{goodform.receivingAddress}}</span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div class="addressBox" v-if="this.num=='0'">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>运单信息
                </span>
              </h4>
              <div>
                <el-table
                  height="300px"
                  size="mini"
                  ref="tabref"
                  :data="this.goodform.sWayList"
                  style="width:100%"
                  class="elTab"
                  border
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                >
                  <el-table-column prop="wayNo" label="运单号" align="center" :formatter="emptyFn"></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="dirverName"
                    label="司机姓名"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="vhcNo"
                    label="车牌号"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="weight"
                    label="调度量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="loadingWeight"
                    label="装车量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column
                    :show-overflow-tooltip="true"
                    prop="unloadingWeight"
                    label="卸车量"
                    align="center"
                    :formatter="emptyFn"
                  ></el-table-column>
                  <el-table-column label="装车凭证" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="QualityClick(scope.row)">查看</el-button>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="" label="货物详情" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="QualityClick2(scope.row)">查看</el-button>
                    </template>
                  </el-table-column> -->
                  <el-table-column
                    prop="receivingTime"
                    label="接单时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="outTime"
                    label="装车时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="arrivalTime"
                    label="到货时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                  <el-table-column
                    prop="signingTime"
                    label="签收时间"
                    align="center"
                    :formatter="dateFormat"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="addressBoxImg addressBox" v-else-if="this.num=='1'">
              <h4 class="title">
                <span>
                  <i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>装卸凭证
                </span>
              </h4>
              <div>
                <ul class="ul">
                  <!-- 装卸车凭证 -->
                  <!-- 装卸车凭证 -->
                  <li>
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="this.goodform.imageUrl"
                      :preview-src-list="srcList"
                    ></el-image>
                  </li>
                  <li>
                    <el-image
                      fit="cover"
                      style="width: 150px; height: 150px"
                      :src="this.goodform.imageUrl2"
                      :preview-src-list="srcList"
                    ></el-image>
                  </li>
                </ul>
                <ul class="ul2">
                  <li>装车凭证</li>
                  <li>卸车凭证</li>
                </ul>
              </div>
            </div>
            <hr />
          </el-form>
        </div>

        <!-- ----------------------------------------------------------------------------------运单 -->

        <div style="width:170px;margin:15px auto;">
          <!-- <el-button type="primary" @click="remarkOk">确定</el-button> -->
          <el-button type="primary" @click="quxiao">关闭</el-button>
        </div>
      </el-dialog>
    </div>

<!-- 应收合计弹框 -->
    <div>
      <el-dialog
        :title="this.hejiDetail"
        :visible.sync="hejiMark"
        :close-on-click-modal="false"

        width="80%"
        center
        :before-close="handleClose"
      >
           <div class="addressBox" >
             <div>
          <p>应收合计:<span style="color:red;font-size:18px">{{formInline.totalAmount}}</span>元</p>
        </div>
              <div>
                <el-table
                  height="300px"
                  size="mini"
                 :data="MXlist"  ref="MXlist"
                  v-loading="loading"
                  style="width:100%"
                  class="elTab"
                  border
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                >

                 <el-table-column property="feeType" label="费目">
                <template scope="scope">{{[ "运费", "服务费","押金","代扣税费"][scope.row.feeType-1]}}</template>
              </el-table-column>
                   <el-table-column property="feeStatus" label="状态">
                <template scope="scope">{{[ "待收款", "已收款",][scope.row.feeStatus-1]}}</template>
              </el-table-column>

                  <el-table-column property="feeStatus" label="费用(元)">
                <template scope="scope">
                  <span v-if="scope.row.feeType!=4">{{scope.row.amount}}</span>
                  <el-button type="text"  size="mini"   @click="shuifeiFn(scope.row)" v-if="scope.row.feeType==4" >{{scope.row.amount}}</el-button>
                  </template>
              </el-table-column>
                </el-table>
              </div>
            </div>
         <div style="width:170px;margin:15px auto;">
          <!-- <el-button type="primary" @click="remarkOk">确定</el-button> -->
          <el-button type="primary" @click="quxiao">关闭</el-button>
        </div>
         <el-dialog  title="代扣税费明细"  :visible.sync="dialogSF" width="600"  append-to-body   :close-oni-click-modal="false" :close-on-press-escape="false" center>
          <div class="table">
            <el-table :data="SFlist"  ref="SFlist" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'  style="width: 100%" center border>
              <el-table-column property="taxReimbursement"  width="120"  :formatter="emptyFn"   label="个人所得税"></el-table-column>
              <el-table-column property="valueAddedTax"  width="120"  :formatter="emptyFn"   label="增值税"></el-table-column>
              <el-table-column property="urbanConstructionTax"  width="120"  :formatter="emptyFn"   label="城建税"></el-table-column>
              <el-table-column property="educationSurtax"  width="120"  :formatter="emptyFn"   label="教育附加费"></el-table-column>
              <el-table-column property="localEducationSurtax"  width="120"  :formatter="emptyFn"   label="地方教育附加"></el-table-column>
              <el-table-column property="stampDuty"  :formatter="emptyFn"   label="印花税"></el-table-column>
          </el-table>
        </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogSF = false">关闭</el-button>
          </span>
      </el-dialog>
      </el-dialog>
    </div>

    <!-- 查看凭证弹框 -->
      <lookVoucher  :row-data="row" v-if="zujianFlag" @destroy="destroy"></lookVoucher>
       <!-- 查看货物详情 -->
      <lookGoodsDetails  :row-data-list="rows" v-if="zujianFlag2" @detailDestroy="detailDestroy"></lookGoodsDetails>
  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { getBtn } from '@/utils/getButton'
import lookGoodsDetails from '@/components/lookGoodsDetails.vue'
import lookVoucher from '@/components/networkFreight/lookVoucher.vue'
import { downstreamSettlementList, downstreamSettlementDetail, sTaxationDetail

} from '@/api/consignment'
import { getListWayByOrderNo } from '@/api/common-signature'
import { emptyFn } from '@/utils/util'

export default {
  name: 'Freight',
  components: {
    lookGoodsDetails,
    lookVoucher
  },
  data () {
    return {
      sun: 0,

      // ----订单详情
      srcList: [],
      goodform: {},
      detailsMark: false,
      num: 0,
      titleDetail: '订单详情',
      loading1: false,
      formFlag: 0,
      drawalStatusFlag: 0,
      loading: false,
      dialogVisible: false,

      hejiMark: false,
      hejiDetail: '应收合计',
      timeFlag: 0,
      typeTime: [
        {
          time: '收款时间：',
          value: '1'
        },
        {
          time: '结清时间：',
          value: '2'
        },
        {
          time: '送达时间：',
          value: '3'
        },
        {
          time: '接单时间：',
          value: '4'
        }
      ],
      typeData: [
        {
          show_name: '全部',
          item_no: ''
        },
        {
          show_name: '待收款',
          item_no: '1301'
        },
        {
          show_name: '已收款',
          item_no: '1303'
        }
      ],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      cangchuTableData: [{ loadingWeight: 3 }],
      // 查询条件
      formInline: {

        timeType: '1'
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['006P00GB001', '006P00GB002'],
      zujianFlag: false, // 凭证
      zujianFlag2: false, // 货物详情
      dataHeji: [],
      tableList: [],
      MXlist: [],
      dialogSF: false,
      SFlist: []

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/freight')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 100 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 代缴代扣弹框
    shuifeiFn (row) {
      sTaxationDetail({ businessNo: row.businessNo }).then(res => {
        this.dialogSF = true
        this.SFlist = res
      })
    },
    // 应收合计
    seeClickHeji (row) {
      this.YFHJfn(row)
    },
    // 应付合计
    YFHJfn (row) {
      downstreamSettlementDetail({ businessNo: row.businessNo }).then(res => {
        this.hejiMark = true
        this.hejiDetail = '应收合计'
        this.MXlist = res.list
        this.formInline.totalAmount = row.totalAmount
      })
    },
    // 获取列表
    getList () {
      let form = {
        settlementType: 3, // 收款方类型
        settlementCode: localStorage.getItem('registerId'), // 收款方code
        pageNo: this.current, // 页数
        pageSize: this.pagesize // 条数
      }
      this.loading = true
      downstreamSettlementList(form).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 点击订单号进入单号页面
    seeClickNO (row) {
      this.detailsMark = true
      // this.num = 0
      this.loading = true
      this.goodform = {}
      this.titleDetail = '订单详情'

      // 1,2--订单  3-运单
      // if (row.source == 1 || row.source == 2) {
      // 订单
      getListWayByOrderNo({

        orderNo: row.orderNo
      })
        .then((res) => {
          if (res != null) {
            this.loading = false
            this.num = 0
            this.goodform = res
            this.sun = '0'
            this.sun = (this.goodform.fatePrice + this.goodform.taxation).toFixed(2)
            // 1.单价，2.包干
            if (this.goodform.pricingMethod == 1) {
              this.goodform.pricingMethod = '单价'
            } else {
              this.goodform.pricingMethod = '包干'
            }
          } else {
            this.loading = false
            DonMessage.error('查无此订单')
          }
        })
        .catch((err) => {
          this.loading = false
          DonMessage.error(err.message)
        })
    },

    // 查询条件1=时间
    changeType (values) {
      // this.formInline.fuTime = ''
      // this.formInline.daoTime = ''
      if (values == 1) {
        this.timeFlag = 0
        this.formInline.daoTime = ''
      } else {
        this.timeFlag = 1
        this.formInline.fuTime = ''
      }
    },
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str =
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.num = 0
    },

    // 点击关闭弹窗
    handleClose (done) {
      this.detailsMark = false
      this.imgMark = false
      this.hejiMark = false
    },
    quxiao () {
      this.detailsMark = false
      this.hejiMark = false

      this.imgMark = false
      this.listImg = []
      this.isAddImg = false

      this.$refs['goodform'].resetFields()
    },

    // 主数据
    sOrderListS () {
      let arr = ''

      if (this.formInline.goodsType == '') {
        arr = ''
      } else {
        arr = this.formInline.goodsType
      }

      downstreamSettlementList({
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        businessNo: this.formInline.businessNo, // d订单号
        settlementStatus: arr, // 结算状态
        settlementTimes: this.formInline.daoTime, // 收款时间
        settlementType: 3, // 收款方类型
        settlementCode: localStorage.getItem('registerId') // 收款方code
      })
        .then((res) => {
          this.xuanzhongArr = []
          this.total = res.total
          this.tableList = res.list
          // this.cangchuTableData.forEach((item, index) => {
          //   //             （2）货主提现：资金流水非必填
          //   // 计价方式1.单价，2.包干
          //   if (item.pricingMethod == 1) {
          //     item.pricingMethod = '按吨'
          //   } else if (item.pricingMethod == 2) {
          //     item.pricingMethod = '包干'
          //   }
          // 1301 待结算，1302 已结算
          // if (item.platformSettlementStatus == 1302) {
          //   item.platformSettlementStatus = ' 已付款'
          //   this.platformSettlementStatusFlag = 0
          // } else if (item.platformSettlementStatus == 1301) {
          //   item.platformSettlementStatus = '待付款'
          //   this.platformSettlementStatusFlag = 1
          // }
          // })
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },

    // 查询
    chaxun () {
      this.sOrderListS()
    },
    // 重置
    chongZhi () {
      this.formInline = { }
      this.sOrderListS()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.sOrderListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.sOrderListS()
    },
    // 凭证
    QualityClick (row) {
      this.row = row
      this.zujianFlag = true
    },
    // 组件销毁
    destroy () {
      this.zujianFlag = false
    },
    // 货物详情
    QualityClick2 (row) {
      this.rows = row
      this.zujianFlag2 = true
    },
    // 组件销毁
    detailDestroy () {
      this.zujianFlag2 = false
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-range-editor--mini.el-input__inner {
  height: 28px;
  width: 315px !important;
}
.avatar-uploader {
  text-align: left !important;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 140px;
  height: 140px;
  line-height: 140px;
  text-align: center;
}
/deep/.el-upload--picture-card {
  background-image: url("../../../../assets/images/upload2.png") !important;
  border: none !important;
}
.hidden /deep/.el-upload--picture-card {
  display: none;
}
.box1B {
  margin-left: 95px !important;

  display: flex !important;
  flex-wrap: wrap !important;
  span {
    // margin-left: 20px !important;
    line-height: 26px !important;
  }
}
.addressBoxTitle {
  div {
    font-size: 22px;
    font-style: 700;
    float: left;
    margin-right: 80px;
  }
}
.addressBoxImg {
  .ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      height: 150px;
      border-radius: 20px;
      overflow: hidden;
      border: 1px dashed #ccc;
      margin-right: 30px;
      text-align: center;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }
  .ul2 {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 150px;
      margin-right: 30px;

      text-align: center;
    }
  }
}
/deep/.inpBox .el-input__inner {
  width: 195px !important;
}
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.el-form-item {
  margin-left: 10px;
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    // margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    text-align: center;
  }
  // border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      // margin-top: 5px;
      width: 100%;

      // border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
</style>
